export enum AlarmChannelType {
    Email = 1,
    Pager = 2,
    Phone = 3,
    SMS = 4
}